import * as React from 'react';
import {connect} from 'react-redux';

import {change, Field, FieldArray, formValueSelector} from 'redux-form';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';
import {FormField} from 'shells/form/form-field';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';

import {PipelineSelectSingle, TagSelect} from '../../../../core/form/fields';

import {STAGESET_RULES_FIELD_NAME, FORM_NAME} from '../create-rules-constants';

import {SpecialCases} from './special-cases';

const createRulesSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        tagIds: createRulesSelector(state, 'tagIds'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onClearTags: () => {
            dispatch(change(FORM_NAME, 'tagIds', []));
        },
    };
}

type StateProps = {
    tagIds: string[];
};

type DispatchProps = {
    onClearTags: () => void;
};

type OwnProps = {
    formId: string;
    hasLeadSpecialCases: boolean;
};

type Props = StateProps & DispatchProps & OwnProps;

export function CreateRulesFormLeadComponent(props: Props) {
    const [addTags, setAddTags] = React.useState<boolean>(
        Boolean(props.tagIds && props.tagIds.length)
    );
    const {onClearTags} = props;

    React.useEffect(() => {
        if (!addTags) {
            onClearTags();
        }
    }, [addTags, onClearTags]);

    return (
        <>
            <StackLegacy spacing={8}>
                <Body>Which pipeline?</Body>
                <Field
                    name='stagesetId'
                    component={PipelineSelectSingle}
                    includeAutoDistribute={true}
                />
            </StackLegacy>
            {props.hasLeadSpecialCases && (
                <FieldArray
                    name={STAGESET_RULES_FIELD_NAME}
                    component={SpecialCases}
                    formId={props.formId}
                />
            )}
            <Divider variant='line--horizontal' spacing={16} />
            <SpacerGroup mb={16}>
                <Body>When this lead is created…</Body>
            </SpacerGroup>
            <FormField innerId='tagIds'>
                <ConditionalCheckboxInput
                    label='Add a tag'
                    isLarge={true}
                    checked={addTags}
                    onChange={(checked) => setAddTags(checked)}
                >
                    <FieldArray
                        name='tagIds'
                        component={TagSelect}
                        shouldAnd={true}
                        tagType='LEAD'
                    />
                </ConditionalCheckboxInput>
            </FormField>
        </>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const CreateRulesFormLead = connector(CreateRulesFormLeadComponent);
